import { MAX_TWO_DECIMALS_REGEX } from 'constants/constants';
import provinceValidation from 'shared/utils/provinceValidation';
import { array, object, number, string, boolean } from 'yup';

export const validationSchema = object().shape({
  locationName: string().required('Required'),
  locationCategory: string().required('Required').nullable(),
  organizationId: string().required('Required').nullable(),
  location: object().shape({
    city: string().required('Required'),
    street: string().required('Required'),
    province: provinceValidation,
    postalCode: string().required('Required'),
  }),
});

export const validationSchemaYears = object({
  years: array().of(
    object({
      year: number().required('Year is required'),
      isActive: boolean(),
      sharePercentage: number().when('isActive', {
        is: true,
        then: number()
          .required('Please enter data or enter 0')
          .typeError('Share percentage must be a number')
          .min(0, 'Share percentage must be at least 0')
          .max(100, 'Share percentage must be at most 100')
          .test(
            'decimal-precision',
            'Share percentage must have at most 2 decimal places',
            value => {
              if (!value) return true;
              return MAX_TWO_DECIMALS_REGEX.test(value.toString());
            }
          ),
        otherwise: number().notRequired(),
      }),
    })
  ),
});
